import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  loadBuddyReferralRequest: ['caId'],
  loadBuddyReferralSuccess: ['buddyReferralDetails'],
  loadBuddyReferralFailure: ['error'],
});

const buddyReferralActions = {
  Types,
  Creators,
};

export default buddyReferralActions;
